import React, { useMemo } from 'react';
import styled from 'styled-components';
import SessionLineupsList from './SessionLineupsList';
import { TLineupEntry } from './SessionLineupsPlayer';
import { PeriodType } from '../../../api';
import { Player } from '../../../services/references';
import { TSession } from '../Sessions';
import { LineupReason } from '../../../services/sessionsUpload';

interface Props {
  lineup?: Array<TLineupEntry>;
  session?: TSession;
  team?: string;
  allPlayers: Array<string>;
  onChangeLineupEntry: (newEntry: TLineupEntry, prevEntry: TLineupEntry) => void;
  onDeleteSubstitution: (entry: TLineupEntry) => void;
  onDeleteRedCard: (entry: TLineupEntry) => void;
  onAddExit: (out: TLineupEntry, reason: LineupReason, outSeconds: number, period: PeriodType) => void;
  onAddSubstitution: (out: TLineupEntry, outSeconds: number, period: PeriodType, playerIn: Player) => void;
}

const SessionLineupsForm: React.FunctionComponent<Props> = ({
  lineup,
  session,
  team,
  allPlayers,
  onChangeLineupEntry,
  onDeleteRedCard,
  onDeleteSubstitution,
  onAddExit,
  onAddSubstitution,
}) => {
  const starting = useMemo(() => {
    return lineup?.filter((l) => !l.inSeconds);
  }, [lineup]);

  const substitutes = useMemo(() => {
    return lineup?.filter((l) => l.inSeconds > 0);
  }, [lineup]);

  return (
    <LineupFormContainer>
      <SessionLineupsList
        width={45}
        header={'Starting lineup'}
        session={session}
        team={team}
        onChangeLineupEntry={onChangeLineupEntry}
        lineup={starting}
        allPlayers={allPlayers}
        onDeleteRedCard={onDeleteRedCard}
        onDeleteSubstitution={onDeleteSubstitution}
        onAddExit={onAddExit}
        onAddSubstitution={onAddSubstitution}
      />
      <SessionLineupsList
        width={55}
        header="Substitutes"
        session={session}
        team={team}
        onChangeLineupEntry={onChangeLineupEntry}
        lineup={substitutes}
        allPlayers={allPlayers}
        onDeleteRedCard={onDeleteRedCard}
        onDeleteSubstitution={onDeleteSubstitution}
        onAddExit={onAddExit}
        onAddSubstitution={onAddSubstitution}
      />
    </LineupFormContainer>
  );
};

const LineupFormContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export default SessionLineupsForm;
